import { render, staticRenderFns } from "./RegisterAdvanced.vue?vue&type=template&id=40b96708&scoped=true&"
import script from "./RegisterAdvanced.vue?vue&type=script&lang=js&"
export * from "./RegisterAdvanced.vue?vue&type=script&lang=js&"
import style0 from "./RegisterAdvanced.vue?vue&type=style&index=0&id=40b96708&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b96708",
  null
  
)

export default component.exports